import { createContext } from 'react';

const PayplusContext = createContext({
  payplusState: {},
  payplusDispatch: () => { }
});

export default PayplusContext;